export const getLastPath = path => path.substring(path.lastIndexOf('/') + 1);

export default {};
